import React from 'react';
import { LiliTransaction } from '../../types/lili-transaction';
import { transactionDescription } from '../../utils/transaction-description';
import { transactionIconImageName } from '../../utils/transaction-icon';
import { LiliToolTip } from '../../../../generic-components/LiliToolTip';

const iconPath = 'https://assets.lili.co/webapp/transactionsv2/';

export const descriptionTemplate = (liliTransaction: LiliTransaction) => {
  const description = transactionDescription(liliTransaction);
  const iconName = transactionIconImageName(liliTransaction);

  const ttStyles = `fadeIn before:w-[10px] before:h-[10px] before:bg-bw07 before:border-bw07 before:border-b before:border-r before:absolute
        before:left-[50%] before:translate-x-[-50%] before:rotate-[45deg] before:translate-y-[55%] before:bottom-0 absolute z-[9999] top-0 left-[50%] translate-x-[-50%]
        translate-y-[calc(-100%-10px)] bg-bw07 border border-bw07 px-[12px] py-[6px] rounded-[6px] shadow-light flex items-center justify-center w-fit max-w-[100%]`;

  return (
    <div className='flex items-center max-w-[100%]'>
      <img src={`${iconPath}${iconName}.svg`} alt={iconName} height={32} width={32} className='mr-[8px]' />
      <LiliToolTip
        childrenClassName={ttStyles}
        conditionalAppearance
        toolTipChildren={
          <span
            className='font-metricR text-[14px] w-full break-words whitespace-nowrap text-bw00'
            id='descriptionValue'
          >
            {description}
          </span>
        }
      >
        <span
          className='font-metricR text-[16px] text-left mr-auto w-fit max-w-[250px] truncate text-bw08'
          id='descriptionValue'
        >
          {description}
        </span>
      </LiliToolTip>
    </div>
  );
};
